module.exports = __webpack_public_path__ + "img/21.efee88a9.png";